import { render, staticRenderFns } from "./MenuMore.vue?vue&type=template&id=07aa873c&scoped=true&"
import script from "./MenuMore.vue?vue&type=script&lang=js&"
export * from "./MenuMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa873c",
  null
  
)

export default component.exports